<main role="main" class="mdc-main-content" id="content">
    <div class="row">
        <div class="row col s12 m12">
            Please enter the Animal ID of the animal that you are looking for to research the outcome of a shelter
            animal.
        </div>
        <div class="row col s12 m12">
            <form [formGroup]="animalSearchForm" (ngSubmit)="onSubmit()">

                <div class="input-field col s12 m8">
                    <input id="animalId" value="A" type="search" formControlName="animalId" prefix="A" mask="0000000"
                        [dropSpecialCharacters]=false
                        [ngClass]="{'is-invalid':submitted && animalSearchForm.controls['animalId'].errors}"
                        style="border: 1px solid #9e9e9e; padding-left: 5px;" class="masked">
                    <span *ngIf="submitted && animalSearchForm.controls['animalId'].errors?.['required']"
                        class="helper-text black-text">
                        Animal ID is required.
                    </span>
                    <span
                        *ngIf="submitted && (animalSearchForm.controls['animalId'].errors?.['minLength'] || animalSearchForm.controls['animalId'].errors?.['maxLength'])"
                        class="helper-text black-text">
                        Animal ID length is 8 characters.
                    </span>
                    <span *ngIf="submitted && animalSearchForm.controls['animalId'].errors?.['pattern']"
                        class="helper-text black-text">
                        Animal ID must start with an (A) and followed with 7 digits (ex: A1234567).
                    </span>
                </div>
                <div class="row col s12 m4">
                    <div class="input-field ">
                        <button type="submit" class="btn btn-md mdc-button--blue submit-button text-center">
                            Search
                        </button>
                    </div>
                    <div *ngIf="spinnerStatus">
                        <!-- <div class="loader">
                        </div> -->
                        <div class="progress">
                            <div class="indeterminate blue" style="width: 70%"></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row col s6 m4 text-center">
                    <div *ngIf="spinnerStatus">
                        <div class="loader">
                        </div>
                    </div>
                </div> -->

            </form>
        </div>

        <div *ngIf="recordNotFound && submitted" class="d-flex align-items-center justify-content-center vh-20">
            <div style="text-align: center;">
                <span>
                    <h1 class="black-text">There is no outcome posted yet for this pet ID number.</h1>
                </span>
                <span class="lead">For more information, please visit the Pet Adoption and Protection Center in Doral or
                    call 311.</span>
            </div>
        </div>
        <div *ngIf="errorResponse && submitted" class="d-flex align-items-center justify-content-center vh-20">
            <div class="text-center">
                <span>
                    <h1 class="black-text">There is no outcome posted yet for this pet ID number.</h1>
                </span>
                <span class="lead">System error. For more information, please visit the Pet Adoption and Protection
                    Center in Doral or call 311.</span>
            </div>
        </div>
    </div>
    <div class="row">
        <div *ngFor="let list of animals let i=index" style="margin-left: 10px; margin-top: 10px;">
            <div class="col s12 m8" [ngModel]="searchOutcomeType(list.outcomeType)">
                <h6>
                    Pet Details
                </h6><br>
                <p><b>Animal ID:</b> {{list.animalId}} </p>
                <p><b>Outcome Type:</b> {{this.outcomeTitle}}</p>
                <p><b>Outcome Date:</b> {{list.outcomeDate | date:'MM/dd/yyyy'}}</p>
                <p style="margin-top:20px; padding-right: 10px;" [innerHTML]="this.outcomeDesc"></p>

            </div>
            <div class="col s12 m4" style="margin-top: 10px;">
                <img src="data:image/jpeg;base64, {{list.image}}" alt="" class="responsive-img"
                    onerror="this.src='./assets/images/ASD_Noimage.jpg';" alt="Pet Image">
            </div>
        </div>
    </div>
</main>